export function webPath(url: string) {
    if (window.location.origin && url) {
        return String(new URL(url, window.location.origin))
    } else {
        return url
    }
}